import SummaryContainer from './SummaryContainer';

export default SummaryContainer;
